var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
import { greys } from "../../global/colors";
var DotDotDot = function (_a) {
    var _b = _a.color, color = _b === void 0 ? greys.mediumDark : _b, props = __rest(_a, ["color"]);
    return (React.createElement(BaseSvgIcon, __assign({ color: color }, props, { viewBox: "0 0 16 16" }),
        React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "none", stroke: color, strokeWidth: 1 }),
        React.createElement("circle", { cx: "4", cy: "8", r: "1" }),
        React.createElement("circle", { cx: "8", cy: "8", r: "1" }),
        React.createElement("circle", { cx: "12", cy: "8", r: "1" })));
};
export default DotDotDot;
